import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const updateData = ({
    id,
    name,
    description,
    facilitatorId,
    date,
    locationId,
    hourId,
    durationId,
    minCapacity,
    maxCapacity,
    credits,
    dimensions,
    gradeLevels,
    requirements,
}) => {
    const course = {
        name,
        description,
        facilitatorId,
        date,
        locationId,
        hourId,
        durationId,
        minCapacity,
        maxCapacity,
        credits,
        dimensions,
        gradeLevels,
        requirements,
    }
    return axios.put(urlGenerator.course(id), course, createRequestConfig()).then(property('data'))
}

export default updateData